export default __webpack_public_path__ + "static/media/eight_img_pay.c399951e.png";